export default __webpack_public_path__ + "static/media/nc.849f0d75.png";